document.addEventListener('DOMContentLoaded', () => {
	const params = new URLSearchParams(location.search);
	if (!Array.from(params.keys()).length) return;

	document.querySelectorAll('.wpcf7-form').forEach((form) => {
		params.forEach((rawValue, key) => {
			const values = rawValue.split(',').map((v) => v.trim()).filter(Boolean);
			if (!values.length) return;

			const selector = `[name="${CSS.escape(key)}"], [name="${CSS.escape(key)}[]"]`;
			const fields = form.querySelectorAll(selector);
			if (!fields.length) return;

			fields.forEach((field) => {
				if (field.type === 'radio' || field.type === 'checkbox') {
					if (values.includes(field.value)) {
						field.checked = true;
					}
				} else {
					field.value = values[0];
				}
			});
		});
	});
});
